import React, { useContext } from 'react';
import compact  from 'lodash/compact';
import { ArrowRight, ArrowLeft } from 'react-feather';
import classnames from 'classnames';

import { ThreeBlocksAndImageFragment } from '../../../../graphql.schema';
import { useImageResize } from '../../../hooks/useImageResize';
import Image from '../../Image';
import { PageContext } from '../../PageContext';
import { v4tov3base } from '../../../lib/mapV4toV3';

import * as styles from './three-blocks-and-image.module.scss';

export const StrapiThreeBlocksAndImage: React.FC<ThreeBlocksAndImageFragment> = ({
  image,
  listHeadingOne,
  listHeadingTwo,
  listHeadingThree,
  listOne,
  listTwo,
  listThree,
}) => {
  const { imageStyle, imageWrapper } = useImageResize(image);
  const { websiteLocale } = useContext(PageContext);
  const { hasRightToLeftLanguage } = v4tov3base({...websiteLocale.attributes});
  return (
    <div className={styles.threeBlocksAndImage}>
      <div className={classnames(styles.firstRow, 'columns is-align-items-flex-end')}>
        <div ref={imageWrapper} className="column is-5">
          <Image image={image} styles={imageStyle} className={styles.image} loading="lazy" />
        </div>
        <div className="column is-6 is-offset-1">
          <h3 className="title is-3 brand-a">{listHeadingOne}</h3>
          {compact(listOne)?.map(({ listItem }, i: number) => (
            <p className="is-text-1 black-2 mb-3 is-flex is-align-items-center" key={`${listItem}-${i}`}>
              {hasRightToLeftLanguage ? <ArrowLeft size={20} className="mr-2 black-4" data-testid="arrow-left"/> : <ArrowRight size={20} className="mr-2 black-4" data-testid="arrow-right"/>} {listItem}
            </p>
          ))}
        </div>
      </div>
      <div className="columns">
        <div className="column is-6">
          <h3 className="title is-3 brand-a">{listHeadingTwo}</h3>
          {compact(listTwo)?.map(({ listItem }, i: number) => (
            <p className="is-text-1 black-2 mb-3 is-flex is-align-items-center" key={`${listItem}-${i}`}>
              {hasRightToLeftLanguage ? <ArrowLeft size={20} className="mr-2 black-4" data-testid="arrow-left"/> : <ArrowRight size={20} className="mr-2 black-4" data-testid="arrow-right"/>} {listItem}
            </p>
          ))}
        </div>
        <div className="column is-6">
          <h3 className="title is-3 brand-a">{listHeadingThree}</h3>
          {compact(listThree)?.map(({ listItem }, i: number) => (
            <p className="is-text-1 black-2 mb-3 is-flex is-align-items-center" key={`${listItem}-${i}`}>
              {hasRightToLeftLanguage ? <ArrowLeft size={20} className="mr-2 black-4" data-testid="arrow-left"/> : <ArrowRight size={20} className="mr-2 black-4" data-testid="arrow-right"/>}
              {listItem}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
